import { render, staticRenderFns } from "./AddOnCreate.vue?vue&type=template&id=625506b3"
import script from "./AddOnCreate.vue?vue&type=script&lang=js"
export * from "./AddOnCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports